export default "__VITE_ASSET__xRhqites__"